import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card-body pb-0" }
const _hoisted_2 = { class: "d-flex align-items-center mb-3" }
const _hoisted_3 = { class: "d-flex align-items-center flex-grow-1" }
const _hoisted_4 = { class: "symbol symbol-45px me-5" }
const _hoisted_5 = { class: "d-flex flex-column" }
const _hoisted_6 = {
  href: "#",
  class: "text-gray-800 text-hover-primary fs-6 fw-bolder"
}
const _hoisted_7 = { class: "text-gray-400 fw-bold" }
const _hoisted_8 = { class: "my-0" }
const _hoisted_9 = {
  type: "button",
  class: "btn btn-sm btn-icon btn-color-primary btn-active-light-primary",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}
const _hoisted_10 = { class: "svg-icon svg-icon-2" }
const _hoisted_11 = { class: "mb-7" }
const _hoisted_12 = { class: "text-gray-800 mb-5" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "separator mb-3" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_avatar = _resolveComponent("avatar")!
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["card", _ctx.widgetClasses])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_avatar, {
              size: "30",
              fullname: _ctx.currentTicket.contactoNombre,
              color: "#c0c0c0"
            }, null, 8, ["fullname"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("a", _hoisted_6, _toDisplayString(_ctx.currentTicket.contactoNombre), 1),
            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.formatDate(_ctx.currentTicket.fechaTicket)), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.currentTicket.contactoEmail), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("button", _hoisted_9, [
            _createElementVNode("span", _hoisted_10, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen024.svg" })
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.currentTicket.comentario), 1)
      ]),
      _hoisted_13
    ])
  ], 2))
}